<template>
  <v-dialog
    :model-value="modelValue"
    @update:model-value="emitClose"
    max-width="600px"
    scrollable
  >
    <v-card class="onest-font rounded-lg p-4">
      <v-card-title class="text-h5 font-bold d-flex align-center">
        Selecionar Projetos
        <v-btn
          icon="mdi-close"
          variant="text"
          size="small"
          class="ml-auto"
          @click="emitClose"
        ></v-btn>
      </v-card-title>

      <v-card-text class="pt-2">
        <!-- Barra de Pesquisa dentro do modal -->
        <v-text-field
          v-model="projectSearchQuery"
          variant="solo"
          flat
          density="compact"
          class="mb-4 border rounded-[15px]"
          placeholder="Buscar projetos por nome ou sigla..."
          append-inner-icon="mdi-magnify"
          hide-details
        ></v-text-field>

        <v-list class="bg-transparent max-h-[300px] overflow-y-auto">
          <v-list-item
            v-for="projeto in filteredModalProjects"
            :key="projeto.id_projeto"
            class="px-1"
          >
            <template #prepend>
              <v-checkbox-btn
                v-model="localSelected"
                :value="projeto.id_projeto"
                color="primary"
              ></v-checkbox-btn>
            </template>
            <v-list-item-title class="font-medium text-gray-900">
              {{ projeto.nome }}
              <v-chip
                v-if="projeto.sigla"
                size="x-small"
                color="primary"
                variant="outlined"
                class="ml-2 font-semibold"
              >
                {{ projeto.sigla }}
              </v-chip>
            </v-list-item-title>
            <v-list-item-subtitle class="text-gray-500">
              Código: {{ projeto.id_projeto }}
            </v-list-item-subtitle>
          </v-list-item>
          <div
            v-if="filteredModalProjects.length === 0"
            class="text-center py-8 text-gray-500"
          >
            Nenhum projeto disponível ou encontrado.
          </div>
        </v-list>
      </v-card-text>

      <v-card-actions class="d-flex justify-end gap-2 pt-4 border-t">
        <v-btn
          color="primary"
          variant="flat"
          class="rounded-full px-6"
          @click="emitConfirm"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalSelecionarProjetos',
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    projetos: {
      type: Array,
      required: true,
    },
    selected: {
      type: Array,
      required: true,
    },
  },
  emits: ['update:modelValue', 'update:selected'],
  data() {
    return {
      projectSearchQuery: '',
      localSelected: [...this.selected],
    };
  },
  watch: {
    selected(newVal) {
      this.localSelected = [...newVal];
    },
    modelValue(newVal) {
      if (newVal) {
        this.localSelected = [...this.selected];
      }
    },
  },
  computed: {
    filteredModalProjects() {
      let list = this.projetos.filter((p) => !p.flencerrado);

      if (this.projectSearchQuery) {
        const query = this.projectSearchQuery.toLowerCase();
        list = list.filter(
          (p) =>
            p.nome.toLowerCase().includes(query) ||
            (p.sigla && p.sigla.toLowerCase().includes(query)),
        );
      }

      return list;
    },
  },
  methods: {
    emitClose() {
      this.$emit('update:modelValue', false);
    },
    emitConfirm() {
      this.$emit('update:selected', this.localSelected);
      this.emitClose();
    },
  },
};
</script>
